export default [
  { key: 'title', label: 'Name', tdClass: 'align-middle w-25' },
  { key: 'isEnabled', label: 'Status', tdClass: 'align-middle' },
];
